import { render } from "./PpcStrategiesModal.vue?vue&type=template&id=5ce37644&scoped=true"
import script from "./PpcStrategiesModal.vue?vue&type=script&lang=js"
export * from "./PpcStrategiesModal.vue?vue&type=script&lang=js"

import "./PpcStrategiesModal.vue?vue&type=style&index=0&id=5ce37644&lang=scss"
import "./PpcStrategiesModal.vue?vue&type=style&index=1&id=5ce37644&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ce37644"]])

export default __exports__